import { useTranslations } from 'next-intl';
import { object, string, ref } from 'yup';

export const getRegisterSchema = (messages = {}) => {
  return object({
    email: string()
      .email(messages.invalid_email || 'Invalid email')
      .required(messages.email_required || 'Email is required'),
    password: string()
      .min(8, messages.password_min_length || 'Password must be at least 8 characters')
      .required(messages.password_required || 'Password is required'),
    repeat_password: string()
      .oneOf([ref('password')], messages.passwords_must_match || 'Passwords must match')
      .required(messages.repeat_password_required || 'Please confirm your password'),
    first_name: string()
      .required(messages.first_name_required || 'First name is required'),
    last_name: string()
      .required(messages.last_name_required || 'Last name is required'),
  });
};

export default function useRegisterSchema() {
  const t = useTranslations('Account');

  const messages = {
    invalid_email: t('error_invalid_email'),
    email_required: t('error_email_required'),
    password_min_length: t('error_password_min_length'),
    password_required: t('error_password_required'),
    passwords_must_match: t('error_passwords_must_match'),
    repeat_password_required: t('error_repeat_password_required'),
    first_name_required: t('error_firstname_required'),
    last_name_required: t('error_lastname_required'),
  };

  return getRegisterSchema(messages);
}